import { FormSubmitMessage } from './FormSubmitMessage';
FormSubmitMessage.displayName = "FormSubmitMessage";
export { FormSubmitMessage as default };